import { Chess } from 'chess.js';

export function isFen(fen?: string) {
  if (!fen) return false;

  return /^([1-8PNBRQK]+\/){7}/i.test(fen);
}

export function isPlayableFen(fen?: string) {
  if (fen) {
    try {
      const validator = new Chess(fen.trim(), { enable960: true });
      const result = !validator.isGameOver() && !validator.isCheck();
      return result;
    } catch {
      // do nothing;
    }
  }

  return false;
}
